module.exports = __webpack_public_path__ + "media/corporate-image/favicon-dcd370dc21e6c38df764fed00f74c401.ico";